import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { assetUrl } from "@/lib/api";

export function PhotoLightbox({ photos = [], index = 0, open, onOpenChange }) {
  const [i, setI] = useState(index);
  useEffect(() => setI(index), [index, open]);
  if (!photos.length) return null;
  const go = (d) => setI((n) => (n + d + photos.length) % photos.length);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl border-0 bg-ink/95 p-2 sm:rounded-none" data-testid="review-photo-lightbox">
        <DialogTitle className="sr-only">Customer photo</DialogTitle>
        <DialogDescription className="sr-only">Photo {i + 1} of {photos.length}</DialogDescription>
        <div className="relative">
          <img src={assetUrl(photos[i]?.url)} alt="Customer review photo" className="mx-auto max-h-[80vh] w-auto object-contain" />
          {photos.length > 1 && (
            <>
              <button type="button" onClick={() => go(-1)} aria-label="Previous photo" className="absolute left-2 top-1/2 grid h-10 w-10 -translate-y-1/2 place-items-center rounded-full bg-ivory/90 text-ink hover:bg-gold hover:text-white">
                <ChevronLeft size={18} />
              </button>
              <button type="button" onClick={() => go(1)} aria-label="Next photo" className="absolute right-2 top-1/2 grid h-10 w-10 -translate-y-1/2 place-items-center rounded-full bg-ivory/90 text-ink hover:bg-gold hover:text-white">
                <ChevronRight size={18} />
              </button>
              <p className="mt-2 text-center text-xs tracking-widest text-ivory/70">{i + 1} / {photos.length}</p>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
